import { z } from "zod";
import { teamsPowerShellTaskSchema } from "./ITeamsPowerShellTask";

export const teamsPowerShellResponseSchema = z.object({
    instanceId: z.string()
        .uuid(),
    tasks: z.array(teamsPowerShellTaskSchema)
});

export type ITeamsPowerShellResponse = z.infer<typeof teamsPowerShellResponseSchema>;